import { CURRENT_PRODUCT_MODE } from '@utils/constants';
import { DEFAULT_DIMENSIONS } from '../base/reducer';

export default (dimensionList, supportedDimensions) => {
  if (Array.isArray(dimensionList)) {
    const filtered = dimensionList.filter((d) => d in supportedDimensions);
    return filtered.length > 0 ? filtered : DEFAULT_DIMENSIONS[CURRENT_PRODUCT_MODE];
  } else {
    return dimensionList in supportedDimensions
      ? dimensionList
      : DEFAULT_DIMENSIONS[CURRENT_PRODUCT_MODE][0];
  }
};
